// extracted by mini-css-extract-plugin
export default {"list":"needs-list_list__SjaBp"};